<template>
  <div>
    <div class="d-flex flex-wrap mt-3">
      <div class="col-md-4 d-flex justify-content-between">
        <span class="title-custom">Inicio de la vigencia </span>
        <input
          type="date"
          class="form-control w-50"
          v-model="iniVigencia"
          @change="changeVigencia()"
          :min="minVigencia"
          :max="maxVigencia"
          onkeydown="return false"
        />
      </div>
      <div class="col-md-4">
        <p>
          <span class="title-custom">Fin de la vigencia </span>
          {{ datosPoliza.FINVIGENCIA }}
        </p>
      </div>
      <div class="col-md-4">
        <p>
          <span class="title-custom">Ocupantes </span>
          {{ datosPoliza.INCISO[0].OCUPANTES }}
        </p>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <hr />
      </div>
    </div>

    <div class="d-flex flex-wrap mt-3">
      <div class="col-md-6">
        <p>
          <span class="title-custom">Forma de pago: </span>
          {{ datosPoliza.FORMAPAGO }}
        </p>
      </div>
      <div class="col-md-6">
        <p>
          <span class="title-custom">Moneda: </span>
          {{ datosPoliza.MONEDA }}
        </p>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <h4 class="mt-4 mb-3 title-custom">
          Cambios solicitados:
          {{
            typeEndoso === 8
              ? "Aumento de coberturas"
              : "Disminución de coberturas"
          }}
        </h4>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="false"
            >
              Vehículo
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile-tab-pane"
              type="button"
              role="tab"
              aria-controls="profile-tab-pane"
              aria-selected="true"
            >
              Coberturas
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact-tab-pane"
              type="button"
              role="tab"
              aria-controls="contact-tab-pane"
              aria-selected="false"
            >
              Mensajes
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Vehículo asegurado</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade show active"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Coberturas a modificar</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th>Paquete</th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cob, i) in cobs" :key="i">
                      <td>
                        <span v-if="i === 0">{{
                          datosPoliza.INCISO[0].PAQUETE
                        }}</span>
                      </td>
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td>
                        <div v-if="cob.SUMAS.length > 1">
                          <select
                            class="form-control"
                            v-model="cob.SUMADEFAULT"
                            @change="
                              recalcPrimaCobs(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(sum, ind) in cob.SUMAS"
                              :key="ind"
                              :value="sum.VALOR"
                            >
                              {{ sum.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>
                          {{ cob.SUMADEFAULT }}
                        </div>
                      </td>
                      <td>
                        <div v-if="cob.DEDUCIBLES.length > 0">
                          <select
                            class="form-control"
                            v-model="cob.DEDUDEFAULT"
                            @change="
                              recalcPrimaCobs(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(ded, ind) in cob.DEDUCIBLES"
                              :key="ind"
                              :value="ded.VALOR"
                            >
                              {{ ded.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>{{ cob.DEDUDEFAULT }}</div>
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input type="checkbox" :checked="true" disabled />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h4 class="title-custom mt-4">Coberturas personalizadas</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cob, i) in cobsExtras" :key="i">
                      <td></td>
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td>
                        <div v-if="cob.SUMAS.length > 1">
                          <select
                            class="form-control"
                            v-model="cob.SUMADEFAULT"
                            @change="
                              recalcPrimaCobsExtra(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(sum, ind) in cob.SUMAS"
                              :key="ind"
                              :value="sum.VALOR"
                            >
                              {{ sum.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>
                          <div v-if="cob.SUMADEFAULT === 'AMPARADA' && cob.CHECKED">
                            AMPARADA
                          </div>
                          <div v-if="cob.SUMADEFAULT === 'AMPARADA' && !cob.CHECKED">
                            -
                          </div>
                          <div v-if="cob.SUMADEFAULT !== 'AMPARADA'">
                            {{ cob.SUMADEFAULT }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div v-if="cob.DEDUCIBLES.length > 0">
                          <select
                            class="form-control"
                            v-model="cob.DEDUDEFAULT"
                            @change="
                              recalcPrimaCobsExtra(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(ded, ind) in cob.DEDUCIBLES"
                              :key="ind"
                              :value="ded.VALOR"
                            >
                              {{ ded.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>{{ cob.DEDUDEFAULT }}</div>
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="cob.CHECKED"
                          :disabled="cob.CHECKEDDEFAULT"
                          @change="
                            recalcPrimaCobsExtra(
                              cob.NOMENCLATURA,
                              cob.SUMADEFAULT,
                              cob.DEDUDEFAULT,
                              i
                            )
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <!-- <h4 class="title-custom mt-4">Protección familiar</h4>

            <div class="row mt-4">
              <div class="col-md-12 mb-2">
                <p>
                  <span style="font-weight: bold">IMPORTANTE: </span>En caso de
                  agregar la cobertura y que el domicilio a cubrir sea
                  diferente, ingresa los datos.
                </p>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="direccion">Dirección</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="direccion">Número exterior</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="direccion">Numero interior</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="direccion">Número exterior</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="direccion">Colonia</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="direccion">Alcaldia</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="direccion">Municipio</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="direccion">Estado</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
            </div>

            <hr /> -->

            <h4 class="title-custom mt-4">Asistencias</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cob, i) in asistencias" :key="i">
                      <td></td>
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td>
                        <div v-if="cob.SUMAS.length > 1">
                          <select
                            class="form-control"
                            v-model="cob.SUMADEFAULT"
                            @change="
                              recalcPrimaAsistencias(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(sum, ind) in cob.SUMAS"
                              :key="ind"
                              :value="sum.VALOR"
                            >
                              {{ sum.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>
                          {{ cob.SUMAS[0].DESCRIPCION }}
                        </div>
                      </td>
                      <td>
                        <div v-if="cob.DEDUCIBLES.length > 0">
                          <select
                            class="form-control"
                            v-model="cob.DEDUDEFAULT"
                            @change="
                              recalcPrimaAsistencias(
                                cob.NOMENCLATURA,
                                cob.SUMADEFAULT,
                                cob.DEDUDEFAULT,
                                i
                              )
                            "
                          >
                            <option
                              v-for="(ded, ind) in cob.DEDUCIBLES"
                              :key="ind"
                              :value="ded.VALOR"
                            >
                              {{ ded.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>{{ cob.DEDUDEFAULT }}</div>
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="cob.CHECKED"
                          :disabled="cob.CHECKEDDEFAULT"
                          @change="
                            recalcPrimaAsistencias(
                              cob.NOMENCLATURA,
                              cob.SUMADEFAULT,
                              cob.DEDUDEFAULT,
                              i
                            )
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <h4 class="title-custom mt-4">Forma de Pago</h4>

            <div class="row mt-4">
              <div class="col-md-6">
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Forma de Pago</label>
                  </div>
                  <div class="col-md-9">
                    <select class="form-control" disabled>
                      <option value="">{{ datosPoliza.FORMAPAGO }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Periodo de pago</label>
                  </div>
                  <div class="col-md-9">
                    <select class="form-control" disabled>
                      <option value="">{{ formaPagoDetalles.periodo }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Paquete</label>
                  </div>
                  <div class="col-md-9">
                    <label>{{ datosPoliza.INCISO[0].PAQUETE }}</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Inicio de Vigencia</label>
                  </div>
                  <div class="col-md-9">
                    <label>{{ datosPoliza.INIVIGENCIA }}</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Fin de Vigencia</label>
                  </div>
                  <div class="col-md-9">
                    <label>{{ datosPoliza.FINVIGENCIA }}</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Duración (días)</label>
                  </div>
                  <div class="col-md-9">
                    <label>{{ formaPagoDetalles.duración }}</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Valor</label>
                  </div>
                  <div class="col-md-9">
                    <label>${{ datosPoliza.VALORVEHICULO }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Primer recibo</label>
                  </div>
                  <div class="col-md-9">
                    <label>${{ formaPagoDetalles.primerRecibo }}</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Subsecuentes</label>
                  </div>
                  <div class="col-md-9">
                    <label>${{ formaPagoDetalles.subsecuente }}</label>
                  </div>
                </div>
              </div>
            </div>

            <h4 class="title-custom mt-4">Vehículo asegurado</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <div
              class="row mt-4 pt-3"
              style="background-color: gainsboro !important"
            >
              <div class="col-md-6">
                <p>Prima neta: ${{ formaPagoDetalles.primaNeta }}</p>
                <p>
                  Recargo por pago fraccionado: ${{
                    formaPagoDetalles.recargoFraccionado
                  }}
                </p>
                <p>
                  Gastos de expedición: ${{
                    formaPagoDetalles.gastosExpedicion
                  }}
                </p>
                <p>Subtotal: ${{ formaPagoDetalles.subtotal }}</p>
              </div>
              <div class="col-md-6">
                <p>I.V.A: ${{ formaPagoDetalles.iva }}</p>
                <p>Articulo 101: ${{ formaPagoDetalles.articulo101 }}</p>
                <p>
                  I.V.A. Articulo 101: ${{ formaPagoDetalles.ivaArticulo101 }}
                </p>
                <p>
                  <span style="color: black !important"
                    >TOTAL: ${{ formaPagoDetalles.total }}</span
                  >
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded mr-2"
                  @click="cerrarEndoso()"
                >
                  Emitir
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="contact-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-tab"
            tabindex="0"
          >
            <div class="row mt-4">
              <div class="col-md-8">
                <p>Mensaje de Suscripción:</p>
                <p>Se envía cotización.</p>
              </div>
              <div class="col-md-4">
                <p>Fecha</p>
                <p>24/08/2022</p>
              </div>
              <div class="col-md-12 mt-3">
                <textarea class="form-control" v-model="comentario"></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <label
                  >Adjunta tus archivos aquí (formato .pdf)
                  <input type="file" class="ml-2" id="file" />
                </label>
              </div>
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="enviarArchivo"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, date } from "../../../../assets/helpers";
import moment from "moment";

export default {
  props: {
    datosPoliza: Object,
    altaFolioInnova: Function,
    typeEndoso: Number,
    endosoCoberturas: Object,
  },
  data() {
    return {
      iniVigencia: this.formatInputDate(
        new Date(format.date(this.datosPoliza.INIVIGENCIA, "aaaa/mm/dd")),
        0
      ),
      minVigencia: this.formatInputDate(
        new Date(format.date(this.datosPoliza.INIVIGENCIA, "aaaa/mm/dd")),
        0
      ),
      maxVigencia: this.formatInputDate(
        new Date(format.date(this.datosPoliza.FINVIGENCIA, "aaaa/mm/dd")),
        0
      ),
      cobs: [],
      cobsExtras: [],
      asistencias: [],
      totalDescuentos: 0,
      formaPagoDetalles: {
        periodo: "",
        duracion: "",
        primerRecibo: 0,
        subsecuente: 0,
        primaNeta: 0,
        recargoFraccionado: 0,
        gastosExpedicion: 0,
        subtotal: 0,
        iva: 0,
        articulo101: 0,
        ivaArticulo101: 0,
        total: 0,
      },
      comentario: "",
      archivos: [],
    };
  },
  methods: {
    filterTypeCobs(cobs, type) {
      return cobs.filter((cob) => cob.TIPO === type);
    },
    async recalcPrimaCobs(nomenclatura, suma, deducible, index) {
      const isEqualLastCob = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) =>
          cob.CLAVECOBERTURA === nomenclatura &&
          (+cob.SUMAASEGURADA === suma ||
            suma === "VALOR COMERCIAL" ||
            suma === "AMPARADA" ||
            suma === 0) &&
          +cob.DEDUCIBLE === deducible
      );

      if (isEqualLastCob) {
        this.cobs[index].PRIMA = 0;
        return;
      }

      const rcTemp = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA === "RC"
      );
      const sumaTemp = nomenclatura === "ERC" ? rcTemp.SUMAASEGURADA : suma;

      await this.getCalcCobs(nomenclatura, sumaTemp, deducible, index, "CA");
    },
    async recalcPrimaCobsExtra(nomenclatura, suma, deducible, index) {
      if (!this.cobsExtras[index].CHECKED) {
        this.cobsExtras[index].PRIMA = 0;
        this.calculaPrimas();
        return;
      }

      const rcTemp = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA === "RC"
      );
      const sumaTemp = nomenclatura === "ERC" ? rcTemp.SUMAASEGURADA : suma;

      await this.getCalcCobs(nomenclatura, sumaTemp, deducible, index, "CP");
    },
    async recalcPrimaAsistencias(nomenclatura, suma, deducible, index) {
      if (!this.asistencias[index].CHECKED) {
        this.asistencias[index].PRIMA = 0;
        this.calculaPrimas();
        return;
      }

      const rcTemp = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA === "RC"
      );
      const sumaTemp = nomenclatura === "ERC" ? rcTemp.SUMAASEGURADA : suma;

      await this.getCalcCobs(nomenclatura, sumaTemp, deducible, index, "A");
    },
    async getCalcCobs(nomenclatura, sumaTemp, deducible, index, type) {
      const payload = {
        metodo: "GET_CALCULO_COBS_CA",
        data: {
          ClaveVehiculo: this.datosPoliza.INCISO[0].CVVEHICULO,
          ModeloVehiculo: this.datosPoliza.INCISO[0].MODELO,
          ClaveCobertura: nomenclatura,
          SumaAsegurada: sumaTemp,
          ValorAuto: this.datosPoliza.VALORVEHICULO,
          Deducible: deducible == "NA" ? "" : deducible,
          EstadoUniverse: this.datosPoliza.ESTADOUNIVERSE,
          PorcentajeDescuento: this.totalDescuentos,
          Kilometraje: this.datosPoliza.INCISO[0].KILOMETRAJE
            ? +this.datosPoliza.INCISO[0].KILOMETRAJE.replaceAll(",", "")
            : 0,
          ClaveAgente: this.datosPoliza.CVAGENTE,
          primaDmpt: this.getPrima("DMPT"),
          primaDmpp: this.getPrima("DM"),
          primaRoboTotal: this.getPrima("RT"),
          primaRespCivil: this.getPrima("RC"),
          primaGastosMedico: this.getPrima("GM"),
          deducibleDMPP: this.getDeducible("DM"),
          deducibleDMPT: this.getDeducible("DMPT"),
          deducibleRT: this.getDeducible("RT"),
          VigenciaInicio: format.date(
            this.datosPoliza.INIVIGENCIA,
            "dd/mm/aaaa"
          ),
          VigenciaFin: format.date(this.datosPoliza.FINVIGENCIA, "dd/mm/aaaa"),
          TipoVigencia: this.datosPoliza.TIPOVIGENCIA,
          BuroCredito: "",
          TIPOMOVIMIENTO: this.typeEndoso === 8 ? "A1" : "D1",
          PRIMACOBERTURA: 0,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(() => {
        const resp = this.$store.getters.getRespuestaREST;

        switch (type) {
          case "CA":
            this.datosPoliza.INCISO[0].COBERTURASASEGURADAS[index].PRIMA =
              resp[0];
            this.calculaPrimas();
            break;
          case "CP":
            this.cobsExtras[index].PRIMA = resp[0];
            this.calculaPrimas();
            break;
          case "A":
            this.asistencias[index].PRIMA = resp[0];
            this.calculaPrimas();
            break;
          default:
            break;
        }
      });
    },
    async getDescuento() {
      const payload = {
        metodo: "GET_DESCUENTOS_CA",
        data: {
          Genero:
            this.datosPoliza.ASEGURADO[0].SEXO === "MASCULINO" ? "M" : "F",
          Edad: date.getAge(
            format.date(
              this.datosPoliza.ASEGURADO[0].FECHANACIMIENTO,
              "aaaa/mm/dd"
            )
          ),
          ClaveVehiculo: this.datosPoliza.INCISO[0].VEHICULO,
          Kilometraje: this.datosPoliza.INCISO[0].KILOMETRAJE
            ? +this.datosPoliza.INCISO[0].KILOMETRAJE.replaceAll(",", "")
            : 0,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(() => {
        const descuentos = this.$store.getters.getRespuestaREST.map(
          (descuento) => descuento.ValorInicio
        );
        this.totalDescuentos = descuentos.join("-");
      });
    },
    async assignChecked() {
      await this.datosPoliza.INCISO[0].COBERTURASASEGURADAS.map((cob) => {
        cob.CHECKED = true;
        cob.CHECKEDDEFAULT = true;
      });

      if (this.typeEndoso === 8) {
        console.log("ENTRA ASSIGNCHECKED");
        await this.datosPoliza.INCISO[0].COBERTURASFALTANTES.map((cob) => {
          cob.CHECKED = false;
          cob.CHECKEDDEFAULT = false;
        });
      }
    },
    async calculaPrimas() {
      const existsRcUsa = this.asistencias.findIndex(
        (bas) => bas.NOMENCLATURA === "RCU" && bas.CHECKED
      );

      const config = {
        metodo: "GET_CALCULO_PRIMAS_CA",
        data: {
          SumaPrimas: this.sumarCoberturas(),
          TipoVigencia: this.datosPoliza.FORMAPAGO,
          VigenciaInicio: format.date(
            this.datosPoliza.INIVIGENCIA,
            "dd/mm/aaaa"
          ),
          VigenciaFin: format.date(this.datosPoliza.FINVIGENCIA, "dd/mm/aaaa"),
          CobRcUsa: existsRcUsa !== -1 ? 1 : 0,
          Tipo: this.typeEndoso === 8 ? "A1" : "D1",
        },
      };
      await this.$store.dispatch("metodoPost", config);

      let detalles = this.$store.getters.getRespuestaREST;

      this.formaPagoDetalles.periodo = detalles[0].DESCRIPCION;
      this.formaPagoDetalles.duración = this.diasEntreFechas(
        this.iniVigencia,
        this.maxVigencia
      );
      this.formaPagoDetalles.primerRecibo = detalles[0].RECIBO1;
      this.formaPagoDetalles.subsecuente = detalles[0].RECIBOSUB;
      this.formaPagoDetalles.primaNeta = detalles[0].PRIMANETA;
      this.formaPagoDetalles.recargoFraccionado = detalles[0].RECARGO;
      this.formaPagoDetalles.gastosExpedicion = detalles[0].GASTOSEXPEDICION;
      this.formaPagoDetalles.subtotal = detalles[0].SUBTOTAL;
      this.formaPagoDetalles.iva = detalles[0].IVA;
      this.formaPagoDetalles.articulo101 = detalles[0].ARTICULO101;
      this.formaPagoDetalles.ivaArticulo101 = detalles[0].IVA101;
      this.formaPagoDetalles.total = detalles[0].PRIMATOTAL;
    },
    async enviarArchivo() {
      const file = document.getElementById("file").files[0];

      if (file) {
        const promise = convert.convertFileToBase64(file);

        promise.then((result) => {
          this.altaFolioInnova(
            {
              base64: result,
              nombre: file.name,
              contentType: file.type,
              extension: "pdf",
            },
            this.typeEndoso === 8 ? "A1" : "D1",
            this.typeEndoso === 8 ? "A" : "D",
            this.comentario
          );
        });
      }
    },
    async cerrarEndoso() {
      const cobsSelecteds = [];
      const cobsNoSelecteds = [];

      this.cobs.map((cob) => {
        if (cob.PRIMA !== 0) {
          cobsSelecteds.push(cob);
        }
      });

      this.cobsExtras.map((cob) => {
        if ((cob.CHECKEDDEFAULT || cob.CHECKED) && cob.PRIMA !== 0) {
          cobsSelecteds.push(cob);
        } else {
          cobsNoSelecteds.push(cob);
        }
      });

      this.asistencias.map((cob) => {
        if ((cob.CHECKEDDEFAULT || cob.CHECKED) && cob.PRIMA !== 0) {
          cobsSelecteds.push(cob);
        } else {
          cobsNoSelecteds.push(cob);
        }
      });

      this.datosPoliza.INCISO[0].COBERTURASASEGURADAS = cobsSelecteds;
      
      if (this.typeEndoso === 8) {
        this.datosPoliza.INCISO[0].COBERTURASFALTANTES = cobsNoSelecteds;
      }

      this.$emit("update:endosoCoberturas", this.formaPagoDetalles);

      this.altaFolioInnova(
        {},
        this.typeEndoso === 8 ? "A1" : "D1",
        this.typeEndoso === 8 ? "A" : "D",
        ""
      );
    },
    sumarCoberturas() {
      let totalCoberturas = 0;
      let totalCoberturasPersonalizadas = 0;
      let totalAsistencias = 0;

      this.cobs.map((cob) => (totalCoberturas = totalCoberturas + cob.PRIMA));
      this.cobsExtras.map(
        (cob) =>
          (totalCoberturasPersonalizadas = cob.CHECKED
            ? totalCoberturasPersonalizadas + cob.PRIMA
            : totalCoberturasPersonalizadas + 0)
      );
      this.asistencias.map(
        (cob) =>
          (totalAsistencias = cob.CHECKED
            ? totalAsistencias + cob.PRIMA
            : totalAsistencias + 0)
      );

      return totalCoberturas + totalCoberturasPersonalizadas + totalAsistencias;
    },
    getDeducible(id) {
      let cobertura = [];

      cobertura = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA == id
      );

      if (!cobertura) {
        return "";
      }
      return cobertura.DEDUCIBLE;
    },
    getPrima(id) {
      let cobertura = [];

      cobertura = this.datosPoliza.INCISO[0].COBERTURAS.find(
        (cob) => cob.CLAVECOBERTURA == id
      );

      if (!cobertura) {
        return "";
      }
      return cobertura.PRIMA;
    },
    formatInputDate(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    changeVigencia() {
      this.datosPoliza.INIVIGENCIA = format.date(
        this.iniVigencia,
        "dd/mm/aaaa"
      );

      this.cobs.map((cob, i) =>
        this.recalcPrimaCobs(
          cob.NOMENCLATURA,
          cob.SUMADEFAULT,
          cob.DEDUDEFAULT,
          i
        )
      );
      this.cobsExtras.map((cob, i) => {
        if (!cob.CHECKEDDEFAULT) {
          this.recalcPrimaCobsExtra(
            cob.NOMENCLATURA,
            cob.SUMADEFAULT,
            cob.DEDUDEFAULT,
            i
          );
        }
      });
      this.asistencias.map((cob, i) => {
        if (!cob.CHECKEDDEFAULT) {
          this.recalcPrimaAsistencias(
            cob.NOMENCLATURA,
            cob.SUMADEFAULT,
            cob.DEDUDEFAULT,
            i
          );
        }
      });
    },
    assignCoberturasAsistencias() {
      this.cobs.push(
        ...this.filterTypeCobs(
          this.datosPoliza.INCISO[0].COBERTURASASEGURADAS,
          1
        )
      );
      this.cobsExtras.push(
        ...this.filterTypeCobs(
          this.datosPoliza.INCISO[0].COBERTURASASEGURADAS,
          3
        )
      );
      this.asistencias.push(
        ...this.filterTypeCobs(
          this.datosPoliza.INCISO[0].COBERTURASASEGURADAS,
          2
        )
      );

      if (this.typeEndoso === 8) {
        console.log("ENTRA ASSIGNCOBERTURASASISTENCIAS");
        this.cobsExtras.push(
          ...this.filterTypeCobs(
            this.datosPoliza.INCISO[0].COBERTURASFALTANTES,
            3
          )
        );

        this.asistencias.push(
          ...this.filterTypeCobs(
            this.datosPoliza.INCISO[0].COBERTURASFALTANTES,
            2
          )
        );
      }
    },
    diasEntreFechas(fecha1, fecha2) {
      const date1 = moment(fecha1);
      const date2 = moment(fecha2);

      return date2.diff(date1, "days");
    },
  },

  async mounted() {
    await this.getDescuento();
    await this.assignChecked();
    await this.assignCoberturasAsistencias();
  },
};
</script>
